var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPagingPrev = function SvgPagingPrev(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6398_17561)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 1.84766,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(90 26 1.84766)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 2.34766,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(90 25.5 2.34766)",
    stroke: "#EAEDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1495 13.8476C12.1495 13.7921 12.1606 13.7337 12.1828 13.6726C12.205 13.6115 12.2439 13.5587 12.2995 13.5143L15.4495 10.3476C15.5273 10.2698 15.6217 10.231 15.7328 10.231C15.8439 10.231 15.9384 10.2698 16.0161 10.3476C16.0939 10.4365 16.1328 10.5282 16.1328 10.6226C16.1328 10.7171 16.0939 10.8032 16.0161 10.881L13.0495 13.8476L16.0161 16.8143C16.0939 16.8921 16.1328 16.981 16.1328 17.081C16.1328 17.181 16.0939 17.2698 16.0161 17.3476C15.9384 17.4254 15.8467 17.4643 15.7411 17.4643C15.6356 17.4643 15.5439 17.4254 15.4661 17.3476L12.2995 14.181C12.2439 14.1365 12.205 14.0865 12.1828 14.031C12.1606 13.9754 12.1495 13.9143 12.1495 13.8476Z",
    fill: "#2f5fed"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6398_17561",
    x: 0,
    y: 0.847656,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0696 0 0 0 0 0.215657 0 0 0 0 0.4104 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6398_17561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6398_17561",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPagingPrev);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "paging-prev.12c0466ba77260b4d2432d536ce9eaab.svg";